import z from '@/lib/zod';
import { REFERRER_DETAIL_SECTIONS } from '@/pages/referrers/lib/referrer-detail-sections';

/**
 * La scheda del dettaglio referrer (`?detailSection=`), accettata dalle liste che
 * lo aprono (referrer dell'admin, agenti del rivenditore). Una scheda
 * sconosciuta scritta a mano diventa «nessuna scheda» invece di far cadere
 * la rotta.
 */
export const referrerDetailSearchSchema = z.object({
  detailSection: z.enum(REFERRER_DETAIL_SECTIONS).optional().catch(undefined),
});
